import Chart from "chart.js";
import moment from "moment";
import React, { Component } from "react";
import PropTypes from "prop-types";
import Timeline from "@material-ui/icons/Timeline";
import withStyles from "@material-ui/core/styles/withStyles";
import { compact, forEach, isEqual, keys, map, sumBy, uniq, values } from "lodash";

import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoGridItem from "components/EnergyCompany/Grid/InfoGridItem.jsx";
import UsinaTooltip from "./UsinaTooltip";
import { COLORS, localeString, numberToBRL } from "services/utils";
import { fulfillWith } from "./utils";

const styles = {
  lastroWrapper: {
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
    marginRight: "25px",
    marginTop: "25px",
  },
};

class MediaMovel extends Component {
  state = {
    saldoMCP: 0,
  };

  componentDidMount() {
    this.handleChart();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.consolidatedEnergy, this.props.consolidatedEnergy) ||
        !isEqual(prevProps.checkedProfiles, this.props.checkedProfiles)) {
      this.handleChart();
    }
  }

  getMediaMovelAndCalculateLastro() {
    const mediaMovelData = [];
    let saldoMCP = 0;

    forEach(values(this.props.consolidatedEnergy), ({ saldo }) => {
      mediaMovelData.push(saldo);
      saldoMCP += saldo;
    });

    this.setState({ saldoMCP });
    return fulfillWith(mediaMovelData, undefined);
  }

  getLabels() {
    let labels = keys(this.props.consolidatedEnergy).map(key => moment(key).format("MMM Y"));
    return fulfillWith(labels, "");
  }

  getLastroEstimadoData() {
    let data = map(values(this.props.consolidatedEnergy), 'lastro');
    return fulfillWith(data, undefined);
  }

  handleChart() {
    const { checkedProfiles, pld } = this.props;
    const selectedSubmarkets = uniq(map(checkedProfiles, 'submarket'));
    const ctx = "chart-media-movel";
    const labels = this.getLabels();
    const mediaMovelData = this.getMediaMovelAndCalculateLastro();
    const lastroEstimadoData = this.getLastroEstimadoData();

    if (this.chart) this.chart.destroy();

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: compact([
          ...map(selectedSubmarkets, (value, index) => {
            const color = COLORS[index];
            return ({
              backgroundColor: color,
              borderColor: color,
              data: values(pld[value]),
              fill: false,
              label: `PLD ${value}`,
              type: 'line',
              yAxisID: 'pld',
            });
          }),
          this.temUsina() && {
            backgroundColor: 'rgba(168, 233, 241, 0.4)',
            borderColor: 'rgba(0, 172, 193, 1)',
            borderWidth: 1,
            data: lastroEstimadoData,
            label: 'Lastro Estimado',
            yAxisID: 'media',
          },
          {
            backgroundColor: 'rgba(54, 162, 235, 0.4)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
            data: mediaMovelData,
            label: 'Saldo MCP',
            yAxisID: 'media',
          },
        ]),
        labels,
      },
      options: {
        scales: {
          yAxes: [
            ...map(selectedSubmarkets, () => {
              return ({
                gridLines: {
                  display: false,
                },
                id: "pld",
                position: "right",
                ticks: {
                  beginAtZero: true,
                  callback: value => `${numberToBRL(value)}/MWh`,
                },
              });
            }),
            {
              id: "media",
              position: "left",
              ticks: {
                beginAtZero: true,
                callback: value => `${localeString(value)} MWh`,
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              if (tooltipItem.datasetIndex + 1 < data.datasets.length) {
                return `${numberToBRL(tooltipItem.yLabel)}/MWh`;
              } else {
                return `${localeString(tooltipItem.yLabel)} MWh`;
              }
            },
          },
          intersect: false,
          mode: 'index',
        },
      },
    });
  }

  temUsina() {
    return sumBy(values(this.props.consolidatedEnergy), 'garantiaFisica') > 0;
  }

  render() {
    const { agentProfile, classes } = this.props;
    const { saldoMCP } = this.state;

    return (
      <GridContainer>
        <GridItem md={12} sm={12} xs={12}>
          <ECCard
            content={
              <div>
                <canvas id="chart-media-movel" />
                <div className={classes.lastroWrapper}>
                  {this.temUsina() && (
                    <InfoGridItem label="Saldo MCP" value={localeString(saldoMCP) + " MWh"} />
                  )}
                  <InfoGridItem label="Lastro" value={localeString(agentProfile.lastro12Meses) + " MWh"} />
                </div>
              </div>
            }
            icon={<Timeline />}
            title={
              <UsinaTooltip
                shouldShow={this.temUsina()}
                title="Lastro Média Móvel"
              />
            }
          />
        </GridItem>
      </GridContainer>
    );
  }
};

MediaMovel.propTypes = {
  agentProfile: PropTypes.array.isRequired,
  checkedProfiles: PropTypes.arrayOf(PropTypes.shape({
    submarket: PropTypes.string.isRequired,
  })).isRequired,
  classes: PropTypes.object.isRequired,
  consolidatedEnergy: PropTypes.objectOf(PropTypes.shape({
    garantiaFisica: PropTypes.number.isRequired,
    lastro: PropTypes.number.isRequired,
    saldo: PropTypes.number.isRequired,
  })).isRequired,
  pld: PropTypes.shape({
    N: PropTypes.object.isRequired,
    NE: PropTypes.object.isRequired,
    S: PropTypes.object.isRequired,
    "SE/CO": PropTypes.object.isRequired,
  }),
};

export default withStyles(styles)(MediaMovel);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/MediaMovel.jsx